import moment from "moment";

function getScrollingImagesScrollDuration() {
    return moment().isoWeekday() * 15 * 1000;
}

export default getScrollingImagesScrollDuration;
